function fileSizeLimit() {
  return function (fileInfo) {
    if (fileInfo.size === null) {
      return
    }
    if (fileInfo.size >= 5000000) {
      throw new Error('size')
    }
  }
}

export const imageValidators = [fileSizeLimit()]
